import { render, staticRenderFns } from "./PayboxFilter.vue?vue&type=template&id=05daca0b&scoped=true&"
import script from "./PayboxFilter.vue?vue&type=script&lang=js&"
export * from "./PayboxFilter.vue?vue&type=script&lang=js&"
import style0 from "./PayboxFilter.vue?vue&type=style&index=0&id=05daca0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05daca0b",
  null
  
)

export default component.exports